// @flow

type StreamSwarmIdBuilderContext = {
  swarmId: string,
  streamType: string,
  properties: Object,
  peerProtocolVersion: string,
}

type ComputeStreamIdentityHash = (properties: Object) => string

type StreamSwarmIdBuilder = (context: StreamSwarmIdBuilderContext) => string

export const createStreamSwarmIdBuilder = (
  computeStreamIdentityHash: ComputeStreamIdentityHash,
): StreamSwarmIdBuilder => ({ swarmId, streamType, properties, peerProtocolVersion }) => {
  const identityHash = computeStreamIdentityHash({ ...properties, bitrate: 0 })

  return `${peerProtocolVersion}-${swarmId}-${streamType}-${identityHash}`
}
